// BEE-22: Singleton Supabase client — import this everywhere you need database access.
//
// Prerequisites before this file compiles cleanly:
//   1. pnpm add @supabase/supabase-js  (run inside Docker)
//   2. Create .env.local with VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY
//   3. Run pnpm gen:types (BEE-25) to replace the stub Database type with real schema types
//
// Never instantiate createClient() elsewhere — use this singleton.

import { createClient } from '@supabase/supabase-js'
import type { Database } from '@/types/database'

export const supabase = createClient<Database>(
  import.meta.env.VITE_SUPABASE_URL as string,
  import.meta.env.VITE_SUPABASE_ANON_KEY as string,
)
